module.exports = __webpack_public_path__ + "img/logo.7b2b763c.png";